import React from 'react'


const Check2 = ({ color, width, height }) => {
  return (
    <svg width={width ||'15'} height={height || '12'} viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.6929 1.79455L15.2013 0.306355C14.9968 0.102144 14.7481 0 14.4557 0C14.163 0 13.9143 0.102144 13.7098 0.306355L6.51484 7.4958L3.2903 4.26763C3.08555 4.06334 2.83696 3.96131 2.54459 3.96131C2.25202 3.96131 2.00343 4.06334 1.79868 4.26763L0.307091 5.75586C0.102338 5.96011 0 6.20821 0 6.50008C0 6.79171 0.102338 7.04004 0.307091 7.24425L4.27734 11.2054L5.76904 12.6936C5.97368 12.898 6.22234 13 6.51484 13C6.80721 13 7.05588 12.8977 7.26063 12.6936L8.75229 11.2054L16.6929 3.28287C16.8975 3.07858 17 2.83052 17 2.53865C17.0002 2.24694 16.8975 1.99884 16.6929 1.79455Z" fill="#33B52A"/>
    </svg>
  )
}


export default Check2

